import React, { useState } from "react";
import { MenuItems } from "./MenuItems";
import "./Dropdown.css";
import { Link } from "react-router-dom";

function CompanyList() {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);
  };

  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? "company clicked" : "company"}
      >
        {MenuItems.map((item, index) => {
          return (
            <>
              <li key={index}>
                <p>
                  <img src={item.icon} alt="icons" srcset="" />
                  <Link
                    className={item.cName}
                    to={item.path}
                    onClick={() => setClick(false)}
                  >
                    {item.title}
                  </Link>
                </p>
              </li>
            </>
          );
        })}
      </ul>
    </>
  );
}

export default CompanyList;
